import 'angular:locale/data:en-US';
import '@angular/localize/init';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-US";
